import { AttackPattern, PatternState } from '../AttackPattern.js';

// The Sovereign teaches a rotating rule: one wedge is safe, the centre is
// dangerous. The safe wedge starts centered on the player (a fair opening
// beat) and rotates from there — see config.rotationSpeed.
export class SovereignSanctum extends AttackPattern {
  constructor({ config }) {
    super({ name: 'Sovereign Sanctum', telegraphDuration: 1.1, activeDuration: 2.8, minPhase: 0, arenaControl: true });
    this.config = config;
  }

  onBegin(boss, player) {
    this._angle = Math.atan2(player.y - boss.y, player.x - boss.x);
    this._tick = 0;
    this._hitTimer = 0;
    this._direction = boss.phase >= 2 ? -1 : 1;
    this._safeWidth = boss.phase >= 1 ? Math.PI / 4 : Math.PI / 3;
  }

  onActiveTick(dt, boss, player, pool) {
    const speed = this.config.rotationSpeed * (boss.phase >= 2 ? 1.45 : boss.phase >= 1 ? 1.15 : 1);
    this._angle += speed * this._direction * dt;
    this._hitTimer -= dt;
    const dx = player.x - boss.x;
    const dy = player.y - boss.y;
    const dist = Math.hypot(dx, dy);
    let diff = Math.atan2(dy, dx) - this._angle;
    while (diff > Math.PI) diff -= Math.PI * 2;
    while (diff < -Math.PI) diff += Math.PI * 2;
    if (this._hitTimer <= 0 && (Math.abs(diff) > this._safeWidth / 2 || dist < this.config.innerDangerRadius)) {
      player.takeDamage(this.config.damage);
      this._hitTimer = 0.42;
    }
    this._tick -= dt;
    if (boss.phase >= 1 && this._tick <= 0) {
      this._tick = 0.8;
      const count = boss.phase >= 2 ? 10 : 8;
      for (let i = 0; i < count; i++) {
        const a = this._angle + (i / count) * Math.PI * 2;
        pool.fire({ x: boss.x, y: boss.y, vx: Math.cos(a) * this.config.shockwaveSpeed, vy: Math.sin(a) * this.config.shockwaveSpeed, radius: 2.5, damage: this.config.shockwaveDamage, color: '#ff8a4a', lifetime: 3 });
      }
    }
  }

  onEnd(boss) { boss.openVulnerability(0.8, 1.6); }

  getVisual(boss) {
    if (this.state !== PatternState.TELEGRAPH && this.state !== PatternState.ACTIVE) return null;
    return { kind: 'sovereignSanctum', x: boss.x, y: boss.y, angle: this._angle, safeWidth: this._safeWidth, innerRadius: this.config.innerDangerRadius, active: this.state === PatternState.ACTIVE };
  }
}
